import { ReactFlowProvider } from '@xyflow/react'
import ChatBotPreview from './ChatBotPreview'

const ChatBotPage = () => {
    return (
        <ReactFlowProvider>
            <ChatBotPreview />
        </ReactFlowProvider>
    )
}

export default ChatBotPage
